var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDown({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M22.2251 7.17142C22.2251 7.37542 22.1571 7.54542 22.0211 7.68142L12.1271 17.5754C11.9911 17.7114 11.8211 17.7794 11.6171 17.7794C11.4131 17.7794 11.2431 17.7114 11.1071 17.5754L1.21309 7.68142C1.09976 7.54542 1.05443 7.38675 1.07709 7.20542C1.07709 7.02409 1.14509 6.86542 1.28109 6.72942C1.39443 6.59342 1.54176 6.52542 1.72309 6.52542C1.90443 6.50275 2.06309 6.54808 2.19909 6.66142L11.6171 16.0794L21.0351 6.66142C21.1484 6.57075 21.2731 6.51408 21.4091 6.49142C21.5451 6.46875 21.6811 6.49142 21.8171 6.55942C21.9304 6.60475 22.0324 6.68408 22.1231 6.79742C22.1911 6.91075 22.2251 7.03542 22.2251 7.17142Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDown);
export default __webpack_public_path__ + "static/media/Down.7dbbe90cd6e7b305aa5e9991d3c14bc6.svg";
export { ForwardRef as ReactComponent };